import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const label = (m) => (m ? `${m.brand || ""} ${m.model}`.trim() : "Sin modelo base");

export const KitComponentsDialog = ({ model, onClose, onSaved }) => {
  const [comps, setComps] = useState(model.kit_components || []);
  const [all, setAll] = useState([]);
  useEffect(() => {
    api.get("/catalog/models", { params: { business_unit_code: "gps" } }).then((r) => setAll(r.data.filter((m) => m.id !== model.id)));
  }, [model.id]);
  const byId = Object.fromEntries(all.map((m) => [m.id, m]));
  const upd = (i, patch) => setComps(comps.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const save = () => api.put(`/catalog/models/${model.id}/kit-components`, { components: comps })
    .then(() => { toast.success("Composición guardada"); onSaved(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-2xl" data-testid="kit-components-dialog">
        <DialogHeader><DialogTitle>Composición · {model.model}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Solo las alternativas autorizadas aquí podrán usarse en la Preparación de la OS. No cambia el precio del kit.</p>
        {comps.map((c, i) => (
          <div key={c.key} className="space-y-2 rounded-lg border border-border p-3" data-testid={`kit-comp-${c.key}`}>
            <div className="text-sm font-medium">{c.quantity} × {c.label} <span className="text-muted-foreground">· base: {label(byId[c.base_model_id])}</span></div>
            <div className="flex flex-wrap gap-1">{c.alternative_model_ids.map((id) => (
              <span key={id} className="flex items-center gap-1 rounded border border-border px-2 py-0.5 text-xs">{label(byId[id])}
                <button onClick={() => upd(i, { alternative_model_ids: c.alternative_model_ids.filter((x) => x !== id) })} data-testid={`kit-comp-${c.key}-remove-${id}`}><X className="h-3 w-3" /></button></span>))}
              {!c.alternative_model_ids.length && <span className="text-xs text-muted-foreground">Sin alternativas autorizadas</span>}</div>
            <select className="h-9 w-full rounded-md border border-border bg-transparent px-2 text-sm" value="" data-testid={`kit-comp-${c.key}-add`}
              onChange={(e) => e.target.value && upd(i, { alternative_model_ids: [...c.alternative_model_ids, e.target.value] })}>
              <option value="">Autorizar alternativa…</option>
              {all.filter((m) => m.id !== c.base_model_id && !c.alternative_model_ids.includes(m.id)).map((m) => <option key={m.id} value={m.id}>{m.type_name} · {label(m)}</option>)}
            </select>
            <Input placeholder="Requisito técnico (p. ej. 256 GB)" value={c.requirement || ""} onChange={(e) => upd(i, { requirement: e.target.value })} data-testid={`kit-comp-${c.key}-requirement`} />
          </div>
        ))}
        <DialogFooter><Button onClick={save} data-testid="kit-components-save">Guardar composición</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
